export default {"src":"/_next/static/media/security-awareness.398f2f95.svg","height":512,"width":487,"blurWidth":0,"blurHeight":0};